// @flow
import type { User } from 'types'
import { post } from 'util/api'

type CreateParams = {
  email: string,
  password: string,
}

export function create(params: CreateParams): Promise<User> {
  return post('/api/tokens', { token: params })
    .then(response => response.json.user)
    .catch(response => {
      const errors = []
      if (response.json) {
        const { code } = response.json
        if (code === 'email_not_found') {
          const { email } = params
          if (/onepreschool\.com/.test(email)) {
            errors.push(`Did you mean to use ${email.replace('onepreschool', 'wonderschool')}?`)
          } else {
            errors.push('We could not find that email address.')
          }
        } else if (code === 'invalid_password') {
          errors.push('This password does not match.')
        }
      }
      if (errors.length === 0) {
        errors.push('There was an error with your submission. Please try again!')
      }
      throw errors
    })
}
